import { render, staticRenderFns } from "./ForgetPasswordNew.vue?vue&type=template&id=19128127&scoped=true&"
import script from "./ForgetPasswordNew.vue?vue&type=script&lang=ts&"
export * from "./ForgetPasswordNew.vue?vue&type=script&lang=ts&"
import style0 from "./ForgetPasswordNew.vue?vue&type=style&index=0&id=19128127&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19128127",
  null
  
)

export default component.exports